export default __webpack_public_path__ + "static/media/contrato_adopcion.7fa509a3.pdf";